import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = {
    url: String
  }

  handleClick(event) {
    event.preventDefault()

    const confirmation = prompt(
      'WARNING: This will permanently delete this tax organizer and ALL associated data ' +
      '(questions, answers, documents, etc.). This action CANNOT be undone.\n\n' +
      'To proceed, please type "CONFIRM" (all caps):'
    )

    if (confirmation === "CONFIRM") {
      this.deleteTaxOrganizer()
    }
  }

  async deleteTaxOrganizer() {
    const button = this.buttonTarget
    const originalHTML = button.innerHTML

    button.disabled = true
    button.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i>Deleting...'

    try {
      const response = await fetch(this.urlValue, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (response.ok && data.success) {
        alert(data.message)
        location.reload()
      } else {
        alert(`Error: ${data.message || 'Failed to delete tax organizer'}`)
        button.disabled = false
        button.innerHTML = originalHTML
      }
    } catch (error) {
      console.error('Error deleting tax organizer:', error)
      alert('An error occurred while deleting the tax organizer')
      button.disabled = false
      button.innerHTML = originalHTML
    }
  }
}
